import { csx } from '@vtex/admin-ui'

export const styles = {
  spinner: csx({ marginLeft: '0.5rem' }),
}
